<template>
  <div v-if="editor">
    <bubble-menu class="bubble-menu" :tippy-options="{ duration: 100 }" :editor="editor">
      <button :class="{ 'is-active': editor.isActive('bold') }" @click="editor.chain().focus().toggleBold().run()">
        Gras
      </button>
      <button :class="{ 'is-active': editor.isActive('italic') }" @click="editor.chain().focus().toggleItalic().run()">
        Italique
      </button>
      <button
        :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
      >
        Titre
      </button>
      <button
        :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
      >
        Sous-titre
      </button>
    </bubble-menu>
    <editor-content class="h-100" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Mention from '@tiptap/extension-mention'
import suggestion from '../popups/suggestion'

export default {
  components: {
    EditorContent,
    BubbleMenu,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    editorClass: {
      type: Array,
      default: () => {
        return []
      },
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
          suggestion,
        }),
      ],
      content: this.value,
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML())
      },
      editorProps: {
        attributes: {
          class: this.editorClass.join(' '),
        },
      },
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  methods: {
    generateJSONMethod() {
      return this.editor.getJSON()
    },

    setContent(content) {
      this.editor.commands.setContent(content)
    },
  },
}
</script>

<style lang="scss">
.text-area {
  min-height: 300px;
  overflow: scroll;
}

.mention {
  font-weight: bold;
  color: #465bfd;
}

.bubble-menu {
  display: flex;
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid #eeeffb;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  button {
    border: none;
    background: none;
    color: #4b4b4b;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0.1rem 0.5rem;
    transition: 0.3s ease all;

    &:hover,
    &.is-active {
      color: #465bfd;
      background: rgba(238, 239, 251, 0.5);
    }
  }
}
</style>
